// Copyright (c) 2016 Deere & Company

import ClaimFailureInfo, {getDefaultState as getClaimFailureInfoDefaultState} from './claim-failure-info';
import ClaimRecordInfo, {getDefaultState as getClaimClaimRecordInfoDefaultState} from './claim-record-info';
import ClaimReferenceInfo, {getDefaultState as getClaimReferenceInfoDefaultState} from './claim-reference-info';
import ClaimValueSummary, {getDefaultState as getClaimValueSummaryDefaultState} from './claim-value-summary';
import CustomerSummary, {getDefaultState as getCustomerSummaryDefaultState} from './customer-summary';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import ClaimAction from './claim-action';
import t from 'tcomb';

const ClaimSearchResult = t.struct({
    allowedActions: t.list(ClaimAction, 'AllowedActions'),
    approvalDate: t.maybe(t.Number),
    claimNumber: t.String,
    claimStatus: KeyValuePair,
    claimType: KeyValuePair,
    claimValueDetails: ClaimValueSummary,
    customerSummary: CustomerSummary,
    failureInfo: ClaimFailureInfo,
    isApproved: t.Bool,
    originalSubmissionDate: t.maybe(t.Number),
    pin: t.String,
    programDescription: t.String,
    programName: t.String,
    recordInfo: ClaimRecordInfo,
    referenceInfo: ClaimReferenceInfo,
    responsibleAccount: Dealer,
    subClaimType: t.maybe(KeyValuePair)
}, {
    name: 'ClaimSearchResult',
    strict: true
});

export const getDefaultState = () => new ClaimSearchResult({
    allowedActions: [],
    approvalDate: null,
    claimNumber: '',
    claimStatus: getKeyValuePairDefaultState(),
    claimType: getKeyValuePairDefaultState(),
    claimValueDetails: getClaimValueSummaryDefaultState(),
    customerSummary: getCustomerSummaryDefaultState(),
    failureInfo: getClaimFailureInfoDefaultState(),
    isApproved: false,
    originalSubmissionDate: null,
    pin: '',
    programDescription: '',
    programName: '',
    recordInfo: getClaimClaimRecordInfoDefaultState(),
    referenceInfo: getClaimReferenceInfoDefaultState(),
    responsibleAccount: getDealerDefaultState()
});

export default ClaimSearchResult;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-search-result.js